import React, { Component } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

import { Text, Box } from '@nerdwallet/currency';
import C3Chart from '../c3-chart/c3-chart';

import './labeled-c3-chart.less';

class LabeledC3Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      centerLabel: '',
      centerAmount: '',
      sliceDescription: '',
    };

    this.onmouseover = this.onmouseover.bind(this);
    this.onmouseout = this.onmouseout.bind(this);
  }

  componentDidMount() {
    this.preloadChartSlice();
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      this.preloadChartSlice();
    }
  }

  onmouseover(d, i) {
    const description = get(this.props.descriptionData, get(d, 'id'));

    // update the state
    setTimeout(() => {
      this.setState({
        centerLabel: d.name,
        centerAmount: `$${d.value.toLocaleString('en-US', {
          maximumFractionDigits: 0,
        })}`,
        sliceDescription: description,
      });

      window.d3.select(i).attr('transform', 'scale(1.1)');

      // Has user provided an onmouseover? If so, call it for them.
      if (get(this.props, 'data.onmouseover')) {
        this.props.data.onmouseover(d, i);
      }
    }, 0);
  }

  onmouseout(d, i) {
    setTimeout(() => {
      // Reset state
      this.setState({
        centerLabel: '',
        centerAmount: '',
        sliceDescription: '',
      });

      window.d3.select(i).attr('transform', 'scale(1)');

      // Has user provided an onmouseout? If so, call it for them.
      if (get(this.props, 'data.onmouseout')) {
        this.props.data.onmouseout(d, i);
      }
    }, 0);
  }

  preloadChartSlice() {
    const defaultDescription = get(
      this.props.descriptionData,
      this.props.defaultExpanded
    );

    if (this.props.defaultExpanded) {
      setTimeout(() => {
        if (get(this.c3chart, 'chart.internal.expandArc')) {
          this.c3chart.chart.internal.expandArc([this.props.defaultExpanded]);
          this.setState({
            centerLabel: this.props.defaultExpanded,
            centerAmount: `$${this.props.data.columns
              .filter(
                (element) => element[0] === this.props.defaultExpanded
              )[0][1]
              .toLocaleString('en-US', { maximumFractionDigits: 0 })}`,
            sliceDescription: defaultDescription,
          });
        }
      }, 1000);
    }
  }

  render() {
    const c3ChartProps = {
      ...this.props,
      data: {
        ...this.props.data,
        onmouseover: this.onmouseover,
        onmouseout: this.onmouseout,
      },
    };

    return (
      <div>
        <C3Chart
          {...c3ChartProps}
          ref={(c) => {
            this.c3chart = c;
          }}
        />
        <Box className="c3-label-center">
          <Text size="small">{this.state.centerLabel}</Text>
        </Box>
        <Box className="c3-label-amount">
          <Text>{this.state.centerAmount}</Text>
        </Box>
        <Box className="c3-label-extra-desc">
          <Text size="small">{this.state.sliceDescription}</Text>
        </Box>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
LabeledC3Chart.displayName = 'LabeledC3Chart';
// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
LabeledC3Chart.propTypes = {
  descriptionData: PropTypes.object,
  data: PropTypes.object,
  defaultExpanded: PropTypes.string,
  uniqueId: PropTypes.string.isRequired,
};

export default LabeledC3Chart;
